import { devices } from './utils';
import constants from './constants';

const {
  i18n: { __ },
  blockEditor: { useSettings },
  components: { PanelBody, SelectControl },
} = wp;

const SpacingTop = ({ spacingTop, setAttributes }) => {
  const [spacingValues] = useSettings(`custom.blockSpacingClasses`) || {};
  const onChangeTopSpacing = (
    paramKey,
    paramValue,
    paramDeviceType,
    paramSpacingTop,
  ) => {
    setAttributes({
      spacingTop: {
        ...paramSpacingTop,
        [paramDeviceType]: {
          ...paramSpacingTop[paramDeviceType],
          settings: {
            ...paramSpacingTop[paramDeviceType].settings,
            [paramKey]: paramValue,
          },
        },
      },
    });
  };

  return (
    <PanelBody title={__('Spacing - Top', 'b3rg')} initialOpen={false}>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        const dropdownOptions =
          Object.keys(spacingValues).length !== 0
            ? spacingValues
            : constants.SPACING_VALUES;
        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <SelectControl
              label={__('Margin', 'b3rg')}
              options={[
                constants.DEFAULT_OPTION,
                ...dropdownOptions.spacingTop[deviceType].margin,
              ]}
              value={spacingTop[deviceType].settings.margin}
              onChange={(value) => {
                onChangeTopSpacing('margin', value, deviceType, spacingTop);
              }}
            />

            <SelectControl
              label={__('Padding', 'b3rg')}
              options={[
                constants.DEFAULT_OPTION,
                ...dropdownOptions.spacingTop[deviceType].padding,
              ]}
              value={spacingTop[deviceType].settings.padding}
              onChange={(value) => {
                onChangeTopSpacing('padding', value, deviceType, spacingTop);
              }}
            />
            <p className="components-panel__help-text">{constants.HELP_TEXT}</p>
          </PanelBody>
        );
      })}
    </PanelBody>
  );
};

export default SpacingTop;
